import { RegionName } from '../types/region.mjs';

const mockRegions = [
    { id: '19', name: RegionName.NEW_YORK },
    { id: '12', name: RegionName.THE_BRONX },
    { id: '16', name: RegionName.BROOKLYN },
    { id: '15', name: RegionName.CONNECTICUT },
    { id: '17', name: RegionName.HUDSON_VALLEY },
    { id: '14', name: RegionName.LONG_ISLAND },
    { id: '13', name: RegionName.NEW_JERSEY },
    { id: '18', name: RegionName.WESTCHESTER }
];

export { mockRegions as default };
//# sourceMappingURL=mockRegions.mjs.map
